/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Revoke_ShareInputs */

const cs_documents_revoke_share = /** @type {(inputs: Documents_Revoke_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílení`)
};

const en_documents_revoke_share = /** @type {(inputs: Documents_Revoke_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shares`)
};

/**
* | output |
* | --- |
* | "Shares" |
*
* @param {Documents_Revoke_ShareInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_revoke_share = /** @type {((inputs?: Documents_Revoke_ShareInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Revoke_ShareInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_revoke_share(inputs)
	return cs_documents_revoke_share(inputs)
});